export default "__VITE_ASSET__79b84d51__"